module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('Toolbar', {
    attrs: {
      "viewName": _vm.viewName,
      "isMenuVisible": _vm.isMenuVisible,
      "platformName": _vm.platformName,
      "currentView": _vm.currentView,
      "isRegistered": _vm.isRegistered
    },
    on: {
      "changeView": _vm.changeView,
      "showDictionary": _vm.openDictionary
    }
  }), _vm._v(" "), _c(_vm.currentView, {
    ref: "childComponent",
    tag: "component",
    attrs: {
      "contentsDetail": _vm.contentsDetail,
      "platformName": _vm.platformName
    },
    on: {
      "changeView": _vm.changeView,
      "setViewName": _vm.setViewName,
      "setMenuVisible": _vm.setMenuVisible,
      "showError": _vm.showError,
      "setIsRegistered": _vm.setIsRegistered,
      "showProcessing": function (showed) { return _vm.showProcessing = showed; }
    }
  }), _vm._v(" "), (_vm.showErrorDialog) ? _c('ErrorDialog', {
    attrs: {
      "message": _vm.errorMessage,
      "buttonKind": _vm.errorButtonKind,
      "platformName": _vm.platformName
    },
    on: {
      "close": function($event) {
        _vm.showErrorDialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNotice) ? _c('Notice', {
    attrs: {
      "platformName": _vm.platformName
    },
    on: {
      "close": function($event) {
        _vm.showNotice = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDictionary) ? _c('Dictionary', {
    attrs: {
      "platformName": _vm.platformName,
      "isModal": _vm.showDictionary
    },
    on: {
      "close": function($event) {
        return _vm.closeDictionary()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showProcessing) ? _c('Processing') : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7b39379a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-7b39379a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Root.vue
// module id = 724
// module chunks = 1